export const sitemapConstants = {
  NEED_RESET: [
    'vhodnye-dveri',
    'mezhkomnatnye-dveri',
  ],
};